import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { ProfileQuestionnairesReadyEvent } from '@studyportals/profile-questionnaires-interfaces';
import { RenderQuestionnaireIncentiveCommand } from '@studyportals/profile-questionnaires-interfaces/commands';
import { Incentives } from '@studyportals/profile-questionnaires-interfaces/enums';

class OnboardingNotificationsIncentive implements ISubscriber<ProfileQuestionnairesReadyEvent> {
	constructor() {
		this.createPlaceholderElement();
		this.initIncentive();
	}

	private createPlaceholderElement(): void {
		const placeholder = document.createElement('div');
		placeholder.setAttribute('data-incentive', 'onboarding_notifications_incentive');
		placeholder.classList.add('ProfileQuestionnaire');

		const internalDiv = document.getElementById('Internal');

		internalDiv?.appendChild(placeholder);
	}

	private initIncentive(): void {
		window.EventAggregationService.subscribeTo(ProfileQuestionnairesReadyEvent.EventType, this, true);
	}
	public notify(event: ProfileQuestionnairesReadyEvent): Promise<void> | void {
		const command = new RenderQuestionnaireIncentiveCommand(Incentives.ONBOARDING_NOTIFICATIONS_INCENTIVE);
		event.profileQuestionnairesApplication.renderIncentive(command);
	}
}

new OnboardingNotificationsIncentive();
